import { Card, Checkbox, Space } from 'antd';
import ProfileKeyClientRow from '../../../profiles/components/ProfileKeyClientRow';
import ImportTitle from './ImportTitle';
import React, {useState} from "react";

const ImportProjectHighlightsStep = ({ accountData, selectedFields, onFieldSelection }) => {
    const [keyClients, setKeyClients] = useState(TB.cloneDeep(accountData.key_clients || []));

    return (
        <div className="py-6">
            <ImportTitle
                title="Project Highlights"
                description="Select the project highlights you'd like to import to your profile"
            />


            <Card title={
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <i className="fas fa-briefcase" />
                        <span>Project Highlights ({keyClients?.length || 0})</span>
                    </div>
                    <Space>
                        <Checkbox
                            checked={keyClients?.every((_, idx) => selectedFields?.key_clients?.[idx])}
                            onChange={(e) => {
                                const newValue = {};
                                keyClients?.forEach((_, idx) => {
                                    newValue[idx] = e.target.checked;
                                });
                                onFieldSelection('key_clients', newValue);
                            }}
                        >
                            <span className="text-xs text-gray-500">Select All</span>
                        </Checkbox>
                    </Space>
                </div>
            }>
                <Space direction="vertical" size={24} style={{ width: '100%' }}>
                    {TB.map(keyClients || [], (client, index) => (
                        <div key={`client-${client.headline}-${index}`} className="flex items-start gap-4 flex-row" >
                            <Space>
                                <Checkbox checked={selectedFields?.key_clients?.[index]}
                                          onChange={(e) => onFieldSelection('key_clients', {
                                              ...(selectedFields?.key_clients || {}),
                                              [index]: e.target.checked
                                          })} />
                            </Space>
                            <div style={{ flex: 1 }}>
                                <div className="-mt-3">
                                    <ProfileKeyClientRow project={client} />
                                </div>
                            </div>
                        </div>
                    ))}
                </Space>
            </Card>
        </div>
    );
};

export default ImportProjectHighlightsStep;